<template>
    <div class="animated efficiency">
        <filters :scope="filtersScope">
        </filters>
        <div class="container-fluid">
            <ProductTabs></ProductTabs>
            <form @submit="checkForm" id="formRent">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card-header-title" v-if="title">
                            {{ title }}
                            <button class="btn btn-success btn-lg btn-check" style="float: right">
                                <i class="fa fa-check-circle"></i>
                                Сохранить
                            </button>
                        </div>
                    </div>
                </div>
                <div class="statistic-wrap" v-if="loading">
                    <div class="card-block">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="logout-message" style="text-align: center;">{{ $t('message.loading') }}
                                    <i aria-hidden="true" class="fa fa-spinner fa-spin"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="statistic-wrap" v-else v-for="row in rows">
                    <div class="card-block"  v-if="loading">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="logout-message" style="text-align: center;">{{ $t('message.loading') }}
                                    <i aria-hidden="true" class="fa fa-spinner fa-spin"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card statistic-table statistic-table-balance">
                        <div class="card-header" v-if="title">
                            {{ row.country }}
                        </div>
                        <div class="card-block card-zz">
                            <table :id="row.id" class="table">
                                <thead>
                                <tr>
                                    <th :colspan="col.colspan" :style="renderBackground(false, col.field, false)" :width="col.width ? col.width : 'auto'" v-for="col in computedHeadColumns">{{ col.label }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="cell in row.goods" v-if="cell.hidden === 0">
                                    <td>
                                        <input :id="'check'+cell.alias + '-'+ cell.country_id" :ishidden="cell.hidden" class="input-check" type="checkbox">
                                    </td>
                                    <td>{{cell.name.value}}</td>
                                    <td @change="changeElem(cell.price.update, cell.remnants.value, $event.target.value, cell.alias, cell.country_id)" style="background-color: #fff9c4;" v-if="cell.remnants.value">
                                        <input :id="'g'+cell.alias" :value="cell.remnants.value" class="input-remnants" type="text">
                                    </td>
                                    <td @change="changeElem(cell.price.update, cell.remnants.value, $event.target.value, cell.alias, cell.country_id)" style="background-color: #fff9c4;" v-else-if="!cell.remnants.value">
                                        <input :id="'g'+cell.alias" class="input-remnants" type="text" value="-">
                                    </td>
                                    <td @change="changeElem(cell.price.update, cell.price.value, $event.target.value, cell.alias, cell.country_id)" style="background-color: #b9f6ca;">
                                        <input :id="'g'+cell.alias" :name="'c'+ cell.country_id" :value="cell.price.value" class="input-price" type="text">
                                    </td>
                                    <td style="background-color: #c8cce6;" v-if="cell.remnants.value">{{cell.priceAll.value.toFixed(2)}}</td>
                                    <td style="background-color: #c8cce6;" v-else-if="!cell.remnants.value"> - </td>
                                </tr>
                                <tr @click="isCheckBox($event, row.id)">
                                    <td></td>
                                    <td v-if="isActive === false"><span class="badge badge-success badge-hidden" style="color: #263238">Скрытые офферы<i aria-hidden="true" class="fa fa-arrow-down" style="margin: 0 5px;"></i></span></td>
                                    <td v-if="isActive === true"><span class="badge badge-success badge-hidden" style="color: #263238">Скрытые офферы<i aria-hidden="true" class="fa fa-arrow-up" style="margin: 0 5px;"></i></span></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr v-for="ce in row.goods" v-if="isActive && ce.hidden === 1">
                                    <td>
                                        <input :id="'check'+ce.alias + '-'+ ce.country_id" :ishidden="ce.hidden" class="input-check" type="checkbox">
                                    </td>
                                    <td>{{ ce.name.value }}</td>
                                    <td @change="changeElem(ce.price.update, ce.remnants.value, $event.target.value, ce.alias, ce.country_id)" style="background-color: #fff9c4;" v-if="ce.remnants.value">
                                        <input :id="'g'+ce.alias" :value="ce.remnants.value" class="input-remnants" type="text">
                                    </td>
                                    <td @change="changeElem(ce.price.update, ce.remnants.value, $event.target.value, ce.alias, ce.country_id)" style="background-color: #fff9c4;" v-else-if="!ce.remnants.value">
                                        <input :id="'g'+ce.alias" class="input-remnants" type="text" value="-">
                                    </td>
                                    <td @change="changeElem(ce.price.update, ce.price.value, $event.target.value, ce.alias, ce.country_id)" style="background-color: #b9f6ca;">
                                        <input :id="'g'+ce.alias" :name="'c'+ ce.country_id" :value="ce.price.value" class="input-price" type="text">
                                    </td>
                                    <td style="background-color: #c8cce6;" v-if="ce.remnants.value">{{ce.priceAll.value.toFixed(2)}}</td>
                                    <td style="background-color: #c8cce6;" v-else-if="!ce.remnants.value"> - </td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <th>Итого:</th>
                                    <th></th>
                                    <th style="background-color: #fff9c4;"><span>{{footColumns[row.id].totalRemnants.value}}</span></th>
                                    <th style="background-color: #b9f6ca;"></th>
                                    <th style="background-color: #c8cce6;"><span>$ {{(footColumns[row.id].totalPrice.value).toFixed(2)}}</span></th>
                                </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import ProductTabs from './ProductTabs.vue'
import Filters from '../../../components/Filters.vue'
import API from '../../../api/API'
import Helper from '../../../api/Helper'
import TypeColor from '../../../assets/TypeColor'
import StatisticTable from '../../../components/StatisticTable.vue'
import { map } from 'lodash'

export default {
  name: 'ProductBalance',
  components: {ProductTabs, StatisticTable, Filters},
  data () {
    return {
      data: [],
      filtersScope: {
        monthFromFilter: true,
        countryFilter: true
      },
      Helper: Helper,
      Storage: Storage,
      date: new Date(),
      isActive: false,
      TypeColor: TypeColor,
      loading: false,
      oldValue: {},
      isShow: true,
      ChangeValue: String,
      title: this.$root.$t('pages.by_balance_currency'),
      rows: [],
      checked: false,
      footColumns: [],
      headColumns: [
        {label: this.$root.$t(''), width: '4%'},
        {label: this.$root.$t('statistic.project'), width: '27%'},
        {label: this.$root.$t('statistic.balance_on_the_first_day_of_the_month'), field: 'processed', width: '27%'},
        {label: this.$root.$t('statistic.price_for_one'), field: 'paidPercents', width: '15%'},
        {label: this.$root.$t('statistic.total_money'), field: 'time_success_call', width: '27%'}
      ]
    }
  },
  computed: {
    computedHeadColumns () {
      if (!this.columns) {
        return this.headColumns
      } else {
        let headColumns = []
        this.headColumns.map((d) => {
          if (this.columns[d.field]) {
            headColumns.push(d)
          }
        })
        return headColumns
      }
    },
    computedRows () {
      if (!this.columns) {
        return this.rows
      } else {
        let rows = []
        this.rows.map((row) => {
          let tmpRow = {}
          map(row, (d, i) => {
            if (this.columns[i] || this.columns[i.replace('Percents', '')]) {
              tmpRow[i] = d
            }
          })
          rows.push(tmpRow)
        })
        return rows
      }
    },
    computedFootColumns () {
      if (!this.columns) {
        return this.footColumns
      } else {
        let footColumns = {}
        map(this.footColumns, (d, i) => {
          if (this.columns[i] || i === 'label' || this.columns[i.replace('Percents', '')]) {
            footColumns[i] = d
          }
        })
        return footColumns
      }
    }
  },
  mounted () {
    setTimeout(() => { this.getData() }, 500)
    this.getCountries()
    this.getGoods()
    this.$root.$on('filters_load_new_data', () => {
      this.getData()
    })
  },
  methods: {
    isCheckBox (e, row) {
      let elem = document.getElementById(row).getAttribute('id')
      if (row === parseInt(elem)) {
        this.isActive = !this.isActive
      }
    },
    renderBackground (cell, i, bc) {
      let style = !cell.style ? {} : cell.style
      if (!cell || (cell.bgg === undefined && !cell.dbgg)) {
        style.backgroundColor = !cell.bgc ? this.TypeColor[i] : cell.bgc
      } else {
        if (!cell.dbgg) {
          if (!cell.bgl) {
            style.background = `linear-gradient(to right, ${!cell.bggc ? this.TypeColor[i] : cell.bggc} ${cell.bgg}%, transparent 0%)`
          } else {
            style.background = `linear-gradient(to left, ${!cell.bggc ? this.TypeColor[i] : cell.bggc} ${cell.bgg}%, transparent 0%)`
            style.position = `relative`
          }
        } else {
          style.background = `linear-gradient(to right, ${this.TypeColor[cell.dbgg[0].name]} ${cell.dbgg[0].width}%, ${this.TypeColor[cell.dbgg[1].name]} ${cell.dbgg[0].width}%, ${this.TypeColor[cell.dbgg[1].name]} ${cell.dbgg[0].width + cell.dbgg[1].width}%, transparent 0%)`
        }
      }
      if (bc.bc) {
        style.backgroundColor = `${bc.bc}`
        style.color = bc.c
      }
      if (cell.bgColorTwo) {
        const summ = Math.abs(cell.bgColorTwo.max.value) + Math.abs(cell.bgColorTwo.min.value)
        const minPercent = ((Math.abs(cell.bgColorTwo.min.value) / summ) * 100).toFixed(0)
        const maxPercent = ((Math.abs(cell.bgColorTwo.max.value) / summ) * 100).toFixed(0)
        let percent
        if (cell.bgColorTwo.value < 0) {
          percent = (Math.abs(cell.bgColorTwo.value) / Math.abs(cell.bgColorTwo.min.value) * minPercent) + parseInt(maxPercent)
          style.background = `linear-gradient(to left, transparent 0%, transparent ${maxPercent}%, ${cell.bgColorTwo.min.color} ${maxPercent}%, ${cell.bgColorTwo.min.color} ${percent}%, transparent ${percent}%, transparent 100%)`
        } else {
          percent = (Math.abs(cell.bgColorTwo.value) / Math.abs(cell.bgColorTwo.max.value) * maxPercent) + parseInt(minPercent)
          style.background = `linear-gradient(to right, transparent 0%, transparent ${minPercent}%, ${cell.bgColorTwo.max.color} ${minPercent}%, ${cell.bgColorTwo.max.color} ${percent}%, transparent ${percent}%, transparent 100%)`
        }
        style.position = `relative`
      }
      return style
    },
    getCountries () {
      API.getCountries()
        .then(response => {
          Storage.countries = response.body
        })
        .catch(response => {
          this.$notify({
            type: 'danger',
            title: this.$root.$t('verbs.error'),
            text: !response.body.message ? response.body : response.body.message,
            animationType: 'velocity'
          })
        })
    },
    getData () {
      this.$root.$emit('data_loading')
      this.loading = true
      this.rows = []
      API.getRemnantsBalance()
      .then(response => {
        this.data = response.body
        let allByDayFoot = {}
        map(Storage.countries, country => {
          let arrGoods = []
          let totalRemnants = null
          let filteredGoods = []
          let allTotalByDay = []
          allByDayFoot[country.id] = {}
          let storageCountry = {
            country: null,
            id: null,
            goods: null,
            remnants: null,
            price: null,
            total: null
          }
          allTotalByDay = {
            countryId: parseInt(country.id),
            totalRemn: 0,
            totalPrice: 0
          }
          map(Storage.goods, byGoods => {
            arrGoods.push({
              alias: byGoods.alias,
              name: {
                value: byGoods.name
              },
              country_id: byGoods.country_id,
              price: {
                value: 0,
                htmlValue: '',
                oldvalue: 0,
                name: '',
                notupdate: this.isShow
              },
              priceAll: {
                value: 0
              },
              remnants: {
                value: 0,
                oldvalue: 0
              },
              flag: null,
              hidden: null
            })
          })
          map(this.data, d => {
            /* allByDayFoot[d.country_id] = {} */
            if (country.id === parseInt(d.country_id)) {
              arrGoods.map(i => {
                if (i.alias === d.alias && parseInt(i.country_id) === parseInt(d.country_id)) {
                  i.price.value = Number(d.price)
                  i.price.notupdate = this.isShow
                  i.remnants.value = parseInt(d.remnants)
                  i.flag = 1
                  i.priceAll.value = Number(d.price) * Number(d.remnants)
                  i.hidden = parseInt(d.hidden)
                }
              })
              filteredGoods = arrGoods.filter(good => good.flag)
              storageCountry = {
                country: Helper.getCountryTitle(Storage.countries, parseInt(d.country_id)),
                id: parseInt(d.country_id),
                goods: filteredGoods,
                total: totalRemnants
              }
            }
          })
          filteredGoods.map(o => {
            if (allTotalByDay.countryId === o.country_id) {
              if (!o.remnants.value && !o.priceAll.value && parseInt(o.hidden) === 0) {
                allTotalByDay.totalRemn += 0
                allTotalByDay.totalPrice += 0
                allTotalByDay.flag = 1
              } else if (!o.priceAll.value && parseInt(o.hidden) === 0) {
                allTotalByDay.totalRemn += o.remnants.value
                allTotalByDay.totalPrice += 0
                allTotalByDay.flag = 1
              } else if (parseInt(o.hidden) === 0) {
                allTotalByDay.totalRemn += o.remnants.value
                allTotalByDay.totalPrice += o.priceAll.value
                allTotalByDay.flag = 1
              }
            }
          })
          allByDayFoot[country.id] = {
            totalRemnants: {
              value: allTotalByDay.totalRemn
            },
            totalPrice: {
              value: allTotalByDay.totalPrice
            }
          }
          this.footColumns = allByDayFoot
          /* this.footColumns = this.footColumns.filter(foot => { return foot.flag }) */
          this.rows.push(storageCountry)
          this.rows = this.rows.filter(i => { return i.country })
        })
        this.loading = false
        this.$root.$emit('data_loaded')
      })
      .catch(response => {
        this.$notify({
          type: 'danger',
          title: this.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        })
      })
    },
    changeElem (update, cell, value, alias, country) {
      if (!update) {
        this.isShow = false
        this.oldValue = cell
        this.ChangeValue = value
        return false
      }
    },
    getGoods () {
      this.$root.$emit('data_loading')
      this.loading = false
      API.getGoods(-1)
        .then(res => {
          this.loading = false
          Storage.goods = res.body
        }).catch(error => {
          console.log(error)
        })
    },
    checkForm: function (e) {
      let post = []
      this.date = Helper.getDateRangeFrom()
      this.date = this.date.substring(11, 18)
      let remn
      let idnum, country, idcheck, checkAttr
      map(e.target.elements, elem => {
        if (elem.className === 'input-remnants') {
          remn = elem.value
        }
        if (elem.name) {
          idnum = elem.id.substring(1)
          country = elem.name.substring(1)
          idcheck = document.getElementById(`check${idnum}-${country}`)
          checkAttr = idcheck.getAttribute('ishidden')
          if (idcheck.checked === true && parseInt(checkAttr) === 0) {
            console.log('true -> 0')
            post.push({
              'country_id': country,
              'product_id': idnum,
              'price': elem.value,
              'stock_balance': remn,
              'month_stat': this.date,
              'hidden': 1
            })
          } else if (idcheck.checked === true && parseInt(checkAttr) === 1) {
            console.log('true -> 1')
            post.push({
              'country_id': country,
              'product_id': idnum,
              'price': elem.value,
              'stock_balance': remn,
              'month_stat': this.date,
              'hidden': 0
            })
          } else if (elem.value || remn) {
            post.push({
              'country_id': country,
              'product_id': idnum,
              'price': elem.value,
              'stock_balance': remn,
              'month_stat': this.date,
              'hidden': parseInt(checkAttr)
            })
          }
        }
      })
      this.loading = true
      API.postRemnantsBalance(post).then(res => {
        this.getData()
        this.loading = false
      })
        .catch(response => {
          this.$root.$emit('data_loaded')
          this.$notify({
            type: 'danger',
            title: this.$root.$t('verbs.error'),
            text: !response.body.message ? response.body : response.body.message,
            animationType: 'velocity'
          })
        })
      e.preventDefault()
    }
  }
}
</script>
<style scoped>
    .badge-hidden {
        padding: 10px;
        border-radius: 5px;
        color: rgb(38, 50, 56);
        background-color: #4dbd744d;
    }
    .card-header-title {
        margin-left: 130px;
        margin-top: 25px;
        padding: 0;
        margin-bottom: 35px;
        font-size: 1.5em;
        text-align: center;
        height: 100%;
    }
  .input-price, .input-remnants {
      border-radius: 10px;
      padding: 0px 30px;
      text-align: center;
      box-shadow: none;
      width: 100px;
      background: transparent;
      outline: none;
      border: none;
  }
  .input-price:hover, .input-remnants:hover {
      cursor: pointer;
  }
  .input-price:focus, .input-remnants:focus {
      border-radius: 0;
      padding: 0px 30px;
      box-shadow: none;
      width: 100px;
      background: transparent;
      outline: none;
      border: 1px solid #1d92dc;
  }

  .container-fluid {
      padding: 0;
  }
  .cellInput{
      background: transparent;
      text-align: center;
      border-radius: 10px !important;
      padding: 0px 10px;
      box-shadow: none;
      width: 100px;
      outline: none;
      border: 1px solid #d6cbcb;
  }
  .cellInput:focus{
      text-align: left;
  }
  .total {
      font-weight: bold;
      border-radius: 5px;
      background-color: #fff9c4;
      padding: 2px 12px;
  }
  .btn-check {
     vertical-align: middle;
  }
    .country-filter {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// ProductBalance.vue?5ef31991